import { EventBroker } from "@frontend/lib/utils/event-broker";

export const OPTIMIZELY_EVENTS = {
    HANDLE_META_FIELDS: 'HANDLE_META_FIELDS'
};

export const optimizelyEventBroker = new EventBroker();
